import axios from "axios";
import { CreateVideoClip } from "src/types"

export async function createVideoClip(data: CreateVideoClip) {
  try {
    const {data: { video_url, subtile_file_url }} = await axios.post(
      `${process.env.REACT_APP_AZURE_CUSTOM_CLIP_URL}`, data
    );
    return { videoUrl: video_url, subtitleUrl: subtile_file_url};
  } catch (error: any) {
    throw new Error(error.response.status === 400
      ? "Der Clip kann nicht erstellt werden, da die Anfrage einen Fehler enthält."
      : "Der Clip kann nicht erstellt werden, da die Funktion derzeit nicht zur Verfügung steht."
    );
  }
}
